import React from 'react';
import '../Styling/documentation.css';

export default function CookiePolicy() {
  return (
    <div className='documentaionContainer'>
      <p className="documentationText">
        <h1 className='documentationHeading'>Cookie Policy</h1>
        <br />
        <p>Welcome to Momentous Holidays! Currently, we do not use any cookies on our website. However, as we continue to enhance our services, we may introduce cookies to improve your browsing experience and provide personalized content. <br /><br /> We value your privacy, and any future use of cookies will adhere to our commitment to transparency and user control. Our intention is to enhance the functionality of our website and better understand how you interact with our content. Any information collected through cookies will be handled in accordance with our Privacy Policy. <br /><br /> When cookies are implemented, we will update this Cookie Policy to inform you of the types of cookies used, their purpose, and how you can manage your cookie preferences. <br /><br /> If you have any questions or concerns about our cookie practices, please <a href="/Contact">Contact Us</a>. Thank you for choosing Momentous Holidays.</p>

      
      </p>
    </div>
  );
}
